import { useQuery } from '@tanstack/react-query';
import { getStudentsForSelect } from '../../api/apiStudents';
import i18next from 'i18next';

export const useGetStudentsForSelect = (filters = {}) => {
    const { isLoading, error, data } = useQuery({
        queryKey: ['students-for-select', filters, i18next.language],
        queryFn: () => getStudentsForSelect(filters),
    });

    return {
        isLoading,
        error,
        studentsOptions: data?.data || [],
    };
};
